import { DatePicker } from "mui-rff";

type Props = {
  name: string;
  label: string;
  disabled?: boolean;
};

export function formatDateOnlyForPicker(value: unknown): unknown {
  if (value == null || value === "") return null;
  if (typeof value !== "string") return value;

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return value;
  }

  return date;
}

export function parseDatePickerValue(value: unknown): unknown {
  if (!(value instanceof Date)) return value;
  if (Number.isNaN(value.getTime())) return value;

  const year = String(value.getFullYear()).padStart(4, "0");
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function DateField({ name, label, disabled }: Props) {
  return (
    <DatePicker
      name={name}
      label={label}
      inputFormat="dd-MM-yyyy"
      mask="__-__-____"
      disabled={disabled}
      fieldProps={{
        format: formatDateOnlyForPicker,
        parse: parseDatePickerValue,
      }}
    />
  );
}
